import browser from '@openclassrooms/utils/browser';
import { ROUTES } from '@openclassrooms/routing';
import { AuthContextId } from 'Modules/auth/constants/constants';

export interface Props {
  authContext?: AuthContextId | undefined;
  targetPath?: string;
}

function RedirectToSignin({ authContext, targetPath = browser.window.location.href }: Props) {
  const urlParams = new URLSearchParams();
  urlParams.append('_target_path', targetPath);

  if (authContext) {
    urlParams.append('context', authContext);
  }

  browser.document.location.replace(`${ROUTES.AUTH.LOGIN}?${urlParams.toString()}`);

  return null;
}

export default RedirectToSignin;
